// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"sidedrawer_SideDrawer__3Y73j","Open":"sidedrawer_Open__6sh6P","Close":"sidedrawer_Close__wrRbB","Logo":"sidedrawer_Logo__1sle4"};